"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistOrLoginForH5 = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var guMember_1 = require("../../model/guMember");
var service_1 = require("../../../library/base/service");
var RegistOrLoginForH5 = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RegistOrLoginForH5, _super);
    function RegistOrLoginForH5() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '注册登录接口';
        _this.code = '300411';
        _this.desc = '注册登录接口';
        _this.requestParams = new guMember_1.RegistOrLoginForH5Request();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return RegistOrLoginForH5;
}(service_1.BaseService));
exports.RegistOrLoginForH5 = RegistOrLoginForH5;
//# sourceMappingURL=registOrLoginForH5.js.map